import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import { useHistory } from "react-router-dom";
import CreateEditForm from "./createEditForm";
import TreeViewDialog from "./dialogs/treeViewDialog/index";
import DuplicateDialog from "./dialogs/duplicateDialog";
import useOnboardingProfiles from "./useOnboardingProfiles";
import { VisibilityIcon } from "@icarius-icons";

const OnboardingProfiles = () => {

  const history = useHistory();

  const {
    isLoading,
    data,
    materialsList,
    trainingList,
    materialTreeData,
    actionTypeList,
    momentList,
    state,
    handlers,
  } = useOnboardingProfiles();

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      onClick={() => history.push(paths.talentAcquisitionSettings)}
      type={"goBack"}
    />
  )

  const createButton = () => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateDialog()}
      type={"add"}
    />
  )

  const modifyButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenEditDialog(gridRef)}
      type={"edit"}
    />
  )

  const duplicateButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("duplicate")}
      onClick={() => handlers.handleOpenDuplicateDialog(gridRef)}
      type={"duplicate"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
      type={"delete"}
    />
  )

  const viewTreeButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("viewVisualizationTree")}
      onClick={() => handlers.handleViewTree(gridRef)}
    >
      <VisibilityIcon />
    </CustomIconButton>
  )

  return (
    <>
      {
        (state.createDialogIsOpen || state.editDialogIsOpen) &&
        <CreateEditForm
          isLoading={isLoading}
          data={state.selectedData}
          allRows={data}
          materialsList={materialsList}
          trainingList={trainingList}
          actionTypeList={actionTypeList}
          momentList={momentList}
          handleClose={handlers.handleCloseCreateEditDialog}
        />
      }
      {
        !(state.createDialogIsOpen || state.editDialogIsOpen) &&
        <CommonPage
          isLoading={isLoading}
          title={getLocalizedString("onboardingProfiles")}
          gridTitle={getLocalizedString("onboardingProfiles")}
          columnDefPage={paths.onboardingProfiles}
          rowData={data}
          menuItems={[
            goBackButton,
            createButton,
            modifyButton,
            viewTreeButton,
            deleteButton,
            duplicateButton,
          ]}
          hasExpand
          hasHelp
        >
          {
            state.duplicateDialogIsOpen &&
            <DuplicateDialog
              allRows={data}
              open={state.duplicateDialogIsOpen}
              data={state.selectedData}
              isLoading={isLoading}
              handleClose={handlers.handleCloseDuplicateDialog}
            />
          }
          {
            state.treeViewDialogIsOpen &&
            <TreeViewDialog
              open={state.treeViewDialogIsOpen}
              data={materialTreeData}
              handleClose={handlers.handleCloseTreeViewDialog}
            />
          }
        </CommonPage>
      }
    </>
  )
}

export default OnboardingProfiles;